type RuntimeEnv = {
  VITE_API_URL?: string;
  VITE_COMPANY_NAME?: string;
  VITE_TENANT_ROOT_DOMAIN?: string;
  VITE_DEBUG?: string;
  VITE_BRAND_NAME?: string;
  VITE_BRAND_NAME_SHORT?: string;
  VITE_BRAND_TAGLINE?: string;
  VITE_BRAND_META_DESCRIPTION?: string;
  VITE_BRAND_META_AUTHOR?: string;
  VITE_BRAND_TWITTER_SITE?: string;
  VITE_BRAND_HERO_EMPHASIS?: string;
  VITE_BRAND_HERO_SUFFIX?: string;
  VITE_BRAND_LOGO_URL?: string;
  VITE_BRAND_FAVICON_URL?: string;
  VITE_BRAND_OG_IMAGE_URL?: string;
  VITE_MOBILE_LAYOUT_V2?: string;
};

const runtimeEnv: RuntimeEnv = (() => {
  if (typeof window === "undefined") {
    return {};
  }

  const globalEnv = (window as Window & { __ENV__?: RuntimeEnv }).__ENV__;
  return globalEnv || {};
})();

export const getRuntimeEnv = (key: keyof RuntimeEnv): string | undefined => {
  if (typeof window !== "undefined") {
    const liveEnv = (window as Window & { __ENV__?: RuntimeEnv }).__ENV__;
    if (liveEnv && Object.prototype.hasOwnProperty.call(liveEnv, key)) {
      return liveEnv[key];
    }
  }

  if (Object.prototype.hasOwnProperty.call(runtimeEnv, key)) {
    return runtimeEnv[key];
  }

  const viteEnv = import.meta.env as Record<string, string | undefined>;
  return viteEnv[key];
};
